import Axios from "axios";
import { getApiConfig } from "../../config/apiConfig";
import { CREATE_TARGETED_CONTENT, GET_ALL_TARGETED_CONTENT, UPDATE_CURRENT_CAMPAIGN, RESET_CURRENT_CAMPAIGN, GET_ACTIVE_TARGETED_CONTENT, END_TARGETED_CONTENT_EARLY } from "../constants/action-types";
import { adalApiFetch } from "../../config/azureConfig";

const API_CONFIG = getApiConfig();

/* 
    Get Campaigns
*/

export const getCampaigns = (callback) => dispatch => {
    adalApiFetch(Axios, `${API_CONFIG.URL}/targeting/GetActiveTargetedContent`, {
        method: "get"
    }).then(res => {

        dispatch({
            type: GET_ALL_TARGETED_CONTENT,
            payload: {
                data: res.data
            }
        });

        callback(true);
    }).catch((error) => {
        console.log(`Exception Occurred: ${error}`);
        callback(false);
    });
};

/* 
    Get Campaign
*/

export const getCampaign = (id, callback) => dispatch => {
    adalApiFetch(Axios, `${API_CONFIG.URL}/targeting/GetCampaignById?id=${id}`, {
        method: "get"
    })
        .then(res => {
            dispatch({
                type: GET_ACTIVE_TARGETED_CONTENT,
                payload: res.data
            });

            callback(true);
        }).catch((error) => {
            console.log(`Exception Occurred: ${error}`);
            callback(false);
        })
};

/* 
    Create Target Group
*/

export const createCampaign = (campaign, callback) => dispatch => {

    const headers = { "Content-Type": "application/json" }

    const startDate = new Date(campaign.StartDate);
    const endDate = new Date(campaign.EndDate);

    const data = {
        "DisplayName": campaign.DisplayName,
        "StartDate": `${startDate.getFullYear()}-${(startDate.getMonth() + 1) < 10 ? `0${startDate.getMonth() + 1}` : startDate.getMonth() + 1}-${startDate.getDate() < 10 ? `0${startDate.getDate()}` : startDate.getDate()}`,
        "EndDate": `${endDate.getFullYear()}-${(endDate.getMonth() + 1) < 10 ? `0${endDate.getMonth() + 1}` : (endDate.getMonth() + 1)}-${endDate.getDate() < 10 ? `0${endDate.getDate()}` : endDate.getDate()}`,
        "TargetGroups": campaign.TargetGroups,
        "TargetContent": campaign.TargetContent
    }

    // { data: data, config: { headers: headers } }

    adalApiFetch(Axios, `${API_CONFIG.URL}/targeting/CreateTargetedContent`, {
        method: "post",
        data: data,
        headers: headers
    })
        .then(res => {
            console.log(res)
            dispatch({
                type: CREATE_TARGETED_CONTENT,
                payload: {
                    campaign
                }
            });

            callback(true);
        }).catch((error) => {
            console.log(`Exception Occurred: ${error.message}`);
            callback(false);
        })
};

/*
    Add Target Groups to current Campaign
*/

export const updateLocalCampaign = (campaign, callback) => dispatch => {
    dispatch({
        type: UPDATE_CURRENT_CAMPAIGN,
        payload: campaign
    });

    callback(true);
};

/*
    Resets current Campaign to initial state
*/

export const resetLocalCampaign = (callback) => dispatch => {
    dispatch({
        type: RESET_CURRENT_CAMPAIGN,
        payload: null
    });

    callback(true);
};

export const updateCampaign = (campaignId, campaign, callback) => dispatch => {
    const headers = { "Content-Type": "application/json" }

    const startDate = new Date(campaign.StartDate);
    const endDate = new Date(campaign.EndDate);

    const data = {
        "id": campaign.id,
        "DisplayName": campaign.DisplayName,
        "ModelType": campaign.ModelType,
        "StartDate": `${startDate.getFullYear()}-${(startDate.getMonth() + 1) < 10 ? `0${startDate.getMonth() + 1}` : startDate.getMonth() + 1}-${startDate.getDate() < 10 ? `0${startDate.getDate()}` : startDate.getDate()}`,
        "EndDate": `${endDate.getFullYear()}-${(endDate.getMonth() + 1) < 10 ? `0${endDate.getMonth() + 1}` : (endDate.getMonth() + 1)}-${endDate.getDate() < 10 ? `0${endDate.getDate()}` : endDate.getDate()}`,
        "TargetGroups": campaign.TargetGroups,
        "TargetContent": campaign.TargetContent
    }
    adalApiFetch(Axios, `${API_CONFIG.URL}/targeting/CreateTargetedContent?id=${campaignId}`, {
        method: "post",
        data: data,
        headers: headers
    })
        .then(res => {
            console.log(res)
            dispatch({
                type: UPDATE_CURRENT_CAMPAIGN,
                payload: campaign
            });

            callback(true);
        }).catch((error) => {
            console.log(`Exception Occurred: ${error.message}`);
            callback(false);
        })
}

export const endCampaignEarly = (campaignId, callback) => dispatch => {
    adalApiFetch(Axios, `${API_CONFIG.URL}/targeting/EndTargetedContentEarly?id=${campaignId}`, {
        method: "post"
    }).then(res => {
        console.log(res)
        dispatch({
            type: END_TARGETED_CONTENT_EARLY,
            payload: campaignId
        });

        callback(true);
    }).catch((error) => {
        console.log(`Exception Occurred: ${error.message}`);
        callback(false);
    })
}